module.exports = __webpack_public_path__ + "img/lingjian.7cb09c40.jpg";